import { None } from "../../lib/misc/option";
import { BaseActionWithNav } from "./BaseActionWithNav";
export class SingletonAction extends BaseActionWithNav {
    constructor() {
        super('SINGLETON');
    }
    on_valid_message() { }
    after_valid_message() {
        return {
            context: 'singleton',
            zoom: false,
            center: false,
            fail: false,
            navigate: None.instance()
        };
    }
}
